<script setup lang="ts">
import { useGetProject } from "~/composables/projects/useGetProject";
import { useListProjects } from "~/composables/projects/useListProjects";
import { useGetWorkspace } from "~/composables/workspaces/useGetWorkspace";

const { project } = useGetProject();
const projectId = useCookie("project_id");
const { projects, loading } = useListProjects();
const { workspace } = useGetWorkspace();

const pjs = computed(() => {
  return projects.value.map((p) => {
    return {
      id: p.id,
      label: p.name,
      avatar: {
        src: "",
        alt: p.name,
        background: "dark:bg-red-100 bg-red-100",
      },
      click: () => {
        project.value = p;
        projectId.value = p.id;
        navigateTo(`/${workspace.value.slug}/${project.value.slug}`);
      },
    };
  });
});

const actions = [
  {
    label: "Create project",
    icon: "i-heroicons-plus-circle",
    click: () => {
      navigateTo(`/onboarding/create-project?workspace=${workspace.value.id}`);
    },
  },
  // {
  //   label: 'Manage projects',
  //   icon: 'i-heroicons-cog-8-tooth',
  //   click: () => {
  //     console.log("manage projects")
  //   }
  // }
];

const p = computed(() => pjs.value.find((i) => i.id === project.value.id) || { avatar: { src: "", alt: "", background: "dark:bg-red-100 bg-red-100" }, label: "", id: "" });
</script>

<template>

  <UDropdown v-slot="{ open }" mode="click" :items="[pjs, actions]" class="w-full" :ui="{ width: 'w-full' }"
    :popper="{ strategy: 'absolute' }">
    <div class="flex items-center space-x-2 w-full px-2" v-if="loading">
      <USkeleton class="h-4 w-4" :ui="{ rounded: 'rounded-full' }" />
      <USkeleton class="h-4 w-full" />
    </div>

    <div class="w-full" v-else>
      <UButton color="gray"  variant="ghost" class="w-full" v-if="projects.length === 0" icon="i-heroicons-plus-circle"
        label="Create project" :to="`/onboarding/create-project?workspace=${workspace.id}`" />

      <UButton color="gray" variant="ghost" :class="[open && 'bg-gray-50 dark:bg-gray-800']" class="w-full" v-else>
        <UAvatar :src="p.avatar.src" :alt="p.avatar.alt" size="2xs" :ui="{background:p.avatar.background}" />

        <span class="truncate text-gray-900 dark:text-white font-semibold">{{ p.label }}</span>
      </UButton>
    </div>
  </UDropdown>
</template>
